import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  draft: {
    companyId: null,

    // Step 1 – Details
    name: "",
    sector: "",
    location: "",
    reportingCurrency: "",
    description: "",

    // Step 2 – Ownership
    partners: [],
    boardRepresentative: "",
    fundFamily: "",
    vintageYear: "",
    grade: "",
    rank: "",

    // Step 3 – Investment
    ownershipPct: "",
    investedCapital: "",
    currentReserves: "",
    totalCapitalBudget: "",
    currentValue: "",
    realisedValue: "",
  },
};

const editCompanySlice = createSlice({
  name: "editCompany",
  initialState,
  reducers: {
    loadCompanyDraft(state, action) {
      state.draft = { ...state.draft, ...action.payload };
    },

    updateField(state, action) {
      const { field, value } = action.payload;
      state.draft[field] = value;
    },

    resetDraft() {
      return initialState;
    },
  },
});

export const {
  loadCompanyDraft,
  updateField,
  resetDraft,
} = editCompanySlice.actions;

export default editCompanySlice.reducer;
